<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Terms of Service</li>
            </ul>
            <h2>Terms of Service</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>



<div class="terms-of-service-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="terms-of-service-content">
                    <!-- <img src="assets/img/courses/img2.jpg" alt="image"> -->
                    <p><i>This Terms of Service was last updated on May 03, 2025.</i></p>
                    <h3> OUR WEBSITE</h3>
                    <p>Our website address is: https/www.happypay.live</p>
                    <blockquote class="blockquote">
                        <p>Welcome to HappyPay Super App & Happy Pay Business App & HappyPay Platform, You
                            further agree and acknowledge the Terms of Use and/or Terms and Conditions that may be
                            applicable to each of the Happy Pay Services provided on Happy Pay Platform. Access to Happy
                            Pay Platform enables you to browse through Happy Pay Services provided by Buddica Global Solutions Pvt. ltd.
                            and in order to avail, enrol or use any such Service/s including but not limited to a
                            comprehensive suite of Banking, Financial and Insurance related products and/or services
                            such as Personal Banking/Corporate Banking/Merchant Banking and/or API Banking
                            products/services and/or such other services, from time to time, you may need to
                            additionally register for such services by providing some more information as required under
                            the Terms of Use of such products/services. Furthermore, you shall provide to any and/or all
                            Service Providers accurate and authentic information, data and/or details about you, your
                            business and/or your customers etc for the purposes of availing any of the Services made
                            available to you by Happy Pay on the HappyPay Platform.</p>
                    </blockquote>
                    <h3> ELIGIBILITY</h3>
                    <p>
                        You must be at least 18 years old and capable of entering into a legally binding contract under applicable law. 
                        By using the Platform, you represent that you meet these eligibility requirements.</p>


                    <h3>DEFINITIONS</h3>
                    <p>"Platform" refers to the HappyPay website, mobile app, and any associated services.
                        "User" refers to any person who accesses or uses the Platform.
                        "Services" include digital payments, mobile recharges, bill payments, money transfers, and other services offered by HappyPay.</p>
                        

                    <h3>ACCOUNT REGISTRATION</h3>
                    <p>To use certain services, you may be required to create an account. You agree to:
                        - Provide accurate, current, and complete information during registration.
                        - Maintain and promptly update your information.
                        - Keep your account credentials confidential.
                        - Be responsible for all activities under your account.
                        We reserve the right to suspend or terminate your account if any information is found to be false or misleading.</p>
                        

                    <h3>USE OF SERVICES</h3>
                    <p>You agree to use the Platform and Services only for lawful purposes and in compliance with:
                        - These Terms
                        - Applicable laws, rules, and regulations
                        - Any additional guidelines provided by us
                        You agree not to:
                        - Violate or infringe the rights of others
                        - Upload, post, or transmit unauthorized content
                        - Attempt to gain unauthorized access to our systems
                        - Use the Platform for fraudulent, illegal, or abusive purposes</p>
                        

                    <h3>SERVICE AVAILABILITY</h3>
                    <p>We strive to ensure continuous availability of our Platform and Services, 
                        but we do not guarantee uninterrupted or error-free operation. We reserve 
                        the right to modify, suspend, or discontinue any feature or service without prior notice.</p>


                    <h3>FEES & CHARGES</h3>
                    <p>Certain transactions or services may incur fees, which will be disclosed at the point of transaction. 
                        You are solely responsible for paying applicable fees and taxes related to your use of the Services.</p>

                    <h3>PAYMENT TERMS</h3>
                    <p>By using our payment services, you authorize us to process transactions on your behalf. Once a transaction is completed, 
                        it cannot be reversed or refunded except as mandated by law or under our refund policies.</p>

                    <h3>REFUND & CANCELLATION PLOICY</h3>
                    <p>All transactions made through the Platform are final and non-refundable, 
                        unless explicitly stated otherwise or required by law. Please verify transaction details before confirming payment.</p>

                    <h3>PRIVACY POLICY</h3>
                    <p>Your privacy is important to us. Our Privacy Policy [insert link] explains how we collect, use, and disclose your information. 
                        By using the Platform, you consent to the collection and use of your data as described in the Privacy Policy.</p>



                    <h3>INTELLECTUAL PROPERTY RIGHTS</h3>
                    <p>All content on the Platform—including text, graphics, logos, software, and trademarks—is owned by 
                        Buddica Global Solutions Pvt Ltd or its licensors. You may not copy, reproduce, modify, 
                        or distribute any part of the Platform without our prior written consent.</p>

                    <h3>THIRD PARTY SERVICES</h3>
                    <p>The Platform may include links or integrations to third-party services. We are not responsible for the content, 
                        policies, or practices of third-party websites or services. Your use of such services is at your own risk.</p>
                       
                     <h3>  LIMITATION OF LIABILITY</h3>
                    <p> To the maximum extent permitted by law, Buddica Global Solutions Pvt Ltd shall not be liable for any indirect, 
                        incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, 
                        or goodwill, arising out of or in connection with:
                        - Your use of the Platform
                        - Any interruption, suspension, or termination of the Platform
                        - Any unauthorized access to or use of our systems
                        Our total liability under these Terms shall not exceed the total amount paid by you for the specific service giving rise to the claim.</p>


                    <h3>INDEMNIFICATION</h3>
                    <p>You agree to indemnify, defend, and hold harmless Buddica Global Solutions Pvt Ltd, 
                        its affiliates, ficers, directors, employees, and agents from and against any claims, liabilities, 
                        damages, losses, or expenses (including legal fees) arising out of or relating to:
                        - Your violation of these Terms
                        - Your misuse of the Platform
                        - Your violation of any applicable laws or rights of third parties</p>
                        
                    <h3>SUSPNESION & TERMINATION</h3>
                    <p>We reserve the right to suspend or terminate your access to the Platform at any time, without notice, 
                        if we determine that you have violated these Terms or engaged in fraudulent or unlawful activities.</p>

                    <h3>GOVERNING & JUDRISDICATION</h3>
                    <p>These Terms are governed by and construed in accordance with the laws of India. Any disputes arising under 
                        these Terms shall be subject to the exclusive jurisdiction of the courts located in [Insert Jurisdiction, Viskhapatnam, INDIA]</p>
                    
                    <h3>AMENDMENTS</h3>
                    <p>We may revise these Terms at any time. Updates will be posted on this page, and the "Effective Date" will be updated accordingly. 
                        Your continued use of the Platform after such changes constitutes acceptance of the revised Terms.</p>
                    
                    <h3>FORCE & MAJUERE</h3>
                    <p>We shall not be held liable for any failure or delay in performance due to causes beyond our reasonable control, including natural disasters, 
                        internet outages, government restrictions, or unforeseen technical failures.</p>
                    
                     <h3>ENTIRE AGREEMENT</h3>
                    <p>These Terms, along with our Privacy Policy and any other legal notices published by us, constitute the entire agreement between you and 
                        Buddica Global Solutions Pvt Ltd regarding your use of the Platform.</p>

                     <h3>CONTACT INFORMATION</h3>
                    <p>For questions, concerns, or legal notices, please contact:
                        Buddica Global Solutions Pvt Ltd
                        Website: www.happypay.live
                        Customer Support: +91-8886327755
                        Email: info.happypay@gmail.com</p>
                        


                </div>
            </div>
            <!-- <div class="col-lg-4 col-md-12">
                <aside class="widget-area">
                    <section class="widget widget_insight">
                        <ul>
                            <li><a routerLink="/about-1">About Us</a></li>
                            <li><a routerLink="/contact">Contact Us</a></li>
                            <li><a routerLink="/purchase-guide">Purchase Guide</a></li>
                            <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                            <li class="active"><a routerLink="/terms-of-service">Terms of Service</a></li>
                        </ul>
                    </section>
                    <section class="widget widget_recent_courses">
                        <h3 class="widget-title">Recent Courses</h3>
                        <article class="item">
                            <a routerLink="/single-courses-1" class="thumb"><span class="fullimage cover bg1" role="img"></span></a>
                            <div class="info">
                                <span>$49.00</span>
                                <h4 class="title usmall"><a routerLink="/single-courses-1">The Data Science Course 2020: Complete Data Science Bootcamp</a></h4>
                            </div>
                            <div class="clear"></div>
                        </article>
                        <article class="item">
                            <a routerLink="/single-courses-1" class="thumb"><span class="fullimage cover bg2" role="img"></span></a>
                            <div class="info">
                                <span>$59.00</span>
                                <h4 class="title usmall"><a routerLink="/single-courses-1">Java Programming Masterclass for Software Developers</a></h4>
                            </div>
                            <div class="clear"></div>
                        </article>
                        <article class="item">
                            <a routerLink="/single-courses-1" class="thumb"><span class="fullimage cover bg3" role="img"></span></a>
                            <div class="info">
                                <span>$69.00</span>
                                <h4 class="title usmall"><a routerLink="/single-courses-1">Deep Learning A-Z™: Hands-On Artificial Neural Networks</a></h4>
                            </div>
                            <div class="clear"></div>
                        </article>
                    </section>
                    <section class="widget widget_tag_cloud">
                        <h3 class="widget-title">Popular Tags</h3>
                        <div class="tagcloud">
                            <a routerLink="/">Business <span class="tag-link-count"> (3)</span></a>
                            <a routerLink="/">Design <span class="tag-link-count"> (3)</span></a>
                            <a routerLink="/">Braike <span class="tag-link-count"> (2)</span></a>
                            <a routerLink="/">Fashion <span class="tag-link-count"> (2)</span></a>
                            <a routerLink="/">Travel <span class="tag-link-count"> (1)</span></a>
                            <a routerLink="/">Smart <span class="tag-link-count"> (1)</span></a>
                            <a routerLink="/">Marketing <span class="tag-link-count"> (1)</span></a>
                            <a routerLink="/">Tips <span class="tag-link-count"> (2)</span></a>
                        </div>
                    </section>
                </aside>
            </div> -->
        </div>
    </div>
</div>